import {ProductAttributeProps} from '@/_application/modules/products/components/attributes/product.attribute';
import cn from 'classnames';

export const CheckboxAttribute = ({attribute, currentOption, isDisabled, onSelected}: ProductAttributeProps) => {
    const handleSelectAttribute = () => {
        if (onSelected && attribute.value_index) {
            onSelected(attribute.value_index);
        }
    };

    const isSelected = currentOption === attribute.value_index;

    return (
        <button
            onClick={handleSelectAttribute}
            aria-label="Ô chọn thuộc tính"
            className={cn('flex cursor-pointer items-center justify-center rounded-full border px-2.5 py-1 text-xs', {
                'border-KPZ_Border bg-white text-KPZ_text_1st': !isSelected,
                'border-primary bg-primary text-white': isSelected,
                'cursor-not-allowed! opacity-50': isDisabled,
            })}
            disabled={isDisabled}>
            {attribute.label}
        </button>
    );
};
